// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-e7acc3fe] {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n.td[data-v-e7acc3fe] {\n  position: relative;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  line-height: 1em;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
